// extracted by mini-css-extract-plugin
export var cartContainer = "_hq-4";
export var gray = "_hq-1";
export var itemContainer = "_hq-2";
export var itemDetails = "_hq-3";
export var strong = "_hq-0";